import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms'; 

import { AppComponent } from './app.component';
import { ShutterComponent } from './shutter/shutter.component';
import { TimesPipe } from './times.pipe';

@NgModule({
  declarations: [
    AppComponent,
    ShutterComponent,
    TimesPipe
  ],
  imports: [
    BrowserModule,
    NgbModule,
    FormsModule,
    BrowserAnimationsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
